import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import CustomHeader from '../ui-kit-dialogicom/inputs/CustomHeader';
import Footer from '../ui-kit-dialogicom/layouts/Footer';
import { DesktopChatWidget } from '../chat';
import { mainHeaderConfig } from '../../config/headerConfig';
import NavigationMenuWithBadges from '../navigation/NavigationMenuWithBadges';
import { getHeaderExtras } from '../../config/headerExtras';

const AdminLayout: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      {/* 1. Turbomanager Header - fixed in alto */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <CustomHeader {...mainHeaderConfig} extraFixed={getHeaderExtras(user)} />
      </div>

      {/* 2. Menu navigazione principale - fixed sotto header, centrato */}
      <div className="fixed left-0 right-0 z-40" style={{ top: '80px' }}>
        <div
          style={{
            width: '100%',
            maxWidth: '1400px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <NavigationMenuWithBadges />
        </div>
      </div>

      {/* Contenuto con padding-top per compensare header+menu */}
      <div
        className="p-4 sm:p-6"
        style={{
          paddingTop: '150px',
          width: '100%',
          maxWidth: '1400px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        {/* 3. Area Amministrazione - Titolo sezione */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-white">Area Amministrazione</h1>
          <p className="text-slate-400">Gestione utenti e gruppi del sistema.</p>
        </div>

        {/* Contenuto pagina (es. Form Profilo) */}
        <div>
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <Footer />

      {/* Chat Widget flottante */}
      <DesktopChatWidget />
    </div>
  );
};

export default AdminLayout;
